import React, { useRef } from 'react';

const Modal = ({ isOpen, onClose, children, className = "max-w-md mx-auto p-6", allowOutsideClick = false, overlayClassName = '' }) => {
  const modalContentRef = useRef(null);

  // Handle clicks outside modal content only if allowOutsideClick is true
  React.useEffect(() => {
    if (!isOpen || allowOutsideClick) return;

    const handleClickOutside = (event) => {
      if (modalContentRef.current && !modalContentRef.current.contains(event.target)) {
        // Prevent closing when clicking outside
        event.preventDefault();
        event.stopPropagation();
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        // Prevent closing with Escape key
        event.preventDefault();
        event.stopPropagation();
      }
    };

    // Add event listeners
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);

    // Cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, allowOutsideClick]);

  if (!isOpen) return null;

  return (
    <div className={['modal-overlay', overlayClassName].filter(Boolean).join(' ')}>
      <div className={`modal-content ${className}`} ref={modalContentRef}>
        {children}
      </div>
    </div>
  );
};

export default Modal;
